import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
import { AdminDataProvider } from './contexts/AdminDataContext';
render(<AdminDataProvider data-id="element-1829">
    <AppRouter data-id="element-1830" />
  </AdminDataProvider>, document.getElementById('root'));